<template>
  <span class="d-inline-flex gap-1 align-items-center">
    <button
      class="btn btn-sm btn-link text-secondary p-0 border-0 text-decoration-none"
      :title="NAV_ITEMS.PostMortem.label"
      @click.stop="navigate('PostMortem')"
    >
      <i :class="[NAV_ITEMS.PostMortem.icon, NAV_ITEMS.PostMortem.colorClass]"></i>
    </button>
    <button
      class="btn btn-sm btn-link text-secondary p-0 border-0 text-decoration-none"
      :title="NAV_ITEMS.Watchlist.label"
      @click.stop="navigate('Watchlist')"
    >
      <i :class="[NAV_ITEMS.Watchlist.icon, NAV_ITEMS.Watchlist.colorClass]"></i>
    </button>
  </span>
</template>

<script>
import { NAV_ITEMS } from '../constants/navItems';

export default {
  name: 'TickerActionButtons',
  props: {
    ticker: {
      type: String,
      required: true,
      validator(value) {
        if (!value || value.trim() === '') {
          console.warn('[TickerActionButtons] ticker prop is missing or empty');
          return false;
        }
        return true;
      }
    }
  },
  data() {
    return { NAV_ITEMS };
  },
  mounted() {
    console.debug(`[TickerActionButtons] mounted with ticker: ${this.ticker}`);
  },
  methods: {
    navigate(routeName) {
      console.debug(`[TickerActionButtons] navigating to ${routeName} for ticker: ${this.ticker}`);
      const resolved = this.$router.resolve({ name: routeName, query: { ticker: this.ticker } });
      window.open(resolved.href, '_blank');
    }
  }
};
</script>
